import { FEMA } from '../../../../assets';
const IconMap = {
  FEMA: FEMA
};
export default IconMap;
//# sourceMappingURL=IconMap.js.map